import { InjectionToken } from '@angular/core';

import { BaasCommonApiClient } from '@lvflanders/bar';

/** Token to resolve BaasCommonApiClient interface. */
export const BAAS_COMMON_API_CLIENT = new InjectionToken<BaasCommonApiClient>('BaasCommonApiClient token.');
